import ConfigProvider from './ConfigProvider';

export { ConfigContext, getRuntimeConfig, RuntimeConfigProvider } from './ConfigProvider';

export type { ConfigProviderProps } from './interface';

export default ConfigProvider;
